import {
  Box,
  Chip,
  SearchField,
  Typography,
} from '@cambridgeassessment/cambridge-ui';
import React, { memo, useCallback, useState } from 'react';
import { hot } from 'react-hot-loader/root';
import { useStyles } from './styles';

interface AutocompleProps {
  allSubjects: any[];
  selectedSubjects: any[];
  className?: string;
  header?: string;
  subheader: string;
  onDelete: (index: number) => void;
  onChange: (event: React.ChangeEvent, value: any) => void;
  getLabel: (item: any) => string;
  placeholder?: string;
}

const AutocompleteWithTags: React.FC<AutocompleProps> = ({
  allSubjects,
  selectedSubjects,
  getLabel,
  onChange,
  onDelete,
  header,
  subheader,
}) => {
  const classes = useStyles();
  const [inputValue, setInputValue] = useState('');
  const [open, setOpen] = useState(false);

  const getSubjectNames = useCallback(
    (subjects) => subjects?.map((subject) => subject.email.description),
    []
  );

  return (
    <Box>
      {header && <Typography variant="subtitle1">{header}</Typography>}
      {subheader && (
        <Box mt="12px" mb="20px">
          <Typography variant="body1">{subheader}</Typography>
        </Box>
      )}
      <SearchField
        id="searchField-subjects"
        containerProps={{
          className: classes.searchField,
        }}
        value={inputValue}
        open={open}
        onChange={(value): void => setInputValue(value)}
        onFocus={(): void => setOpen(true)}
        onClickAway={(): void => setOpen(false)}
        dropdownVariant="suggested"
        onDropdownItemSelect={(item) => {
          onChange(
            undefined,
            allSubjects.find((subject) => subject.email.description === item)
          );
          setInputValue('');
          setOpen(false);
        }}
        suggestedSearchResults={getSubjectNames(allSubjects)
          .map((item) => ({
            text: item,
          }))
          .filter(
            (subject) =>
              !getSubjectNames(selectedSubjects)?.includes(subject.text) &&
              subject.text.toLowerCase().includes(inputValue?.toLowerCase())
          )}
      />
      <Box className={classes.tags}>
        {selectedSubjects?.map((item, index) => {
          return (
            <Chip
              tabIndex={-1}
              label={getLabel(item)}
              key={index}
              size="small"
              onDelete={() => {
                onDelete(index);
              }}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default hot(memo(AutocompleteWithTags));
